<template>
  <div v-if="isReady">
    <div id="homeapp">
      <header style="box-shadow: none; z-index: 996">
        <div stats-projectpage="60" class="header">
          <div class="head-left">
            <h1>
              <a
                href="/home/"
                class="head-logo"
                style="position: relative; margin-right: 100px; display: block; width: 95px; height: 36px"
              >
                <img src="/home/img/logo.png" class="logo" style="position: absolute; z-index: 999" />
              </a>
            </h1>
          </div>
          <div class="head-right">
            <ul id="menulist">
              <li><a target="_blank" href="https://sscms.com">首 页</a></li>
              <li><a target="_blank" href="https://sscms.com/cms/">产 品</a></li>
              <li><a target="_blank" href="https://sscms.com/cloud/">网站云</a></li>
              <li><a target="_blank" href="https://sscms.com/templates/">模 板</a></li>
              <li><a target="_blank" href="https://sscms.com/plugins/">插 件</a></li>
              <li><a target="_blank" href="https://sscms.com/docs/">文 档</a></li>
              <li><a target="_blank" href="https://sscms.com/partners/">生 态</a></li>
              <li><a target="_blank" href="https://sscms.com/aboutus/">关 于</a></li>
              <li><a target="_blank" href="https://sscms.com/docs/v7/updates/">版本更新</a></li>

              <li class="menu-more" v-if="user.userName === 'sscms'">
                <a href="javascript:void(0);">
                  系统管理
                  <i class="iconfont icon-xiangxiajiantou"></i>
                </a>
                <ul class="more-list">
                  <li class="more-item">
                    <a href="/home/#admin/tickets/" class="cooperation">工单管理</a>
                  </li>
                  <li class="more-item">
                    <a href="/home/#admin/serviceCodes/" class="cooperation">服务码管理</a>
                  </li>
                  <li class="more-item">
                    <a href="/home/#admin/invoices/" class="cooperation">发票管理</a>
                  </li>
                  <li class="more-item">
                    <a href="/home/#admin/contacts/" class="cooperation">咨询管理</a>
                  </li>
                  <li class="more-item">
                    <a href="/home/#admin/nodes/" class="cooperation">服务器管理</a>
                  </li>
                  <li class="more-item">
                    <a href="/home/#admin/hosts/" class="cooperation">网站云管理</a>
                  </li>
                  <li class="more-item">
                    <a href="/home/#admin/clouds/" class="cooperation">云助手管理</a>
                  </li>
                  <li class="more-item">
                    <a href="/home/#admin/images/" class="cooperation">免版权图库管理</a>
                  </li>
                  <li class="more-item">
                    <a href="/home/#admin/users/" class="cooperation">用户管理</a>
                  </li>
                  <li class="more-item">
                    <a href="/home/#admin/orders/" class="cooperation">订单管理</a>
                  </li>
                  <li class="more-item">
                    <a href="/home/#admin/v7/" class="cooperation">V7</a>
                  </li>
                  <li class="more-item">
                    <a href="/home/#admin/v6/" class="cooperation">V6</a>
                  </li>
                  <li class="more-item">
                    <a href="/home/#admin/tags/" class="cooperation">标签管理</a>
                  </li>
                  <li class="more-item">
                    <a href="/home/#admin/extensions/" class="cooperation">插件管理</a>
                  </li>
                  <li class="more-item">
                    <a href="/home/#admin/themes/" class="cooperation">模板管理</a>
                  </li>
                  <li class="more-item">
                    <a href="/home/#admin/backups/" class="cooperation">备份管理</a>
                  </li>
                  <li class="more-item">
                    <a href="/home/#admin/healths/" class="cooperation">健康检查</a>
                  </li>
                  <li class="more-item">
                    <a href="/home/#admin/logsError/" class="cooperation">系统错误</a>
                  </li>
                  <li class="more-item">
                    <a href="/home/#admin/utilities/" class="cooperation">Utilities</a>
                  </li>
                </ul>
              </li>
            </ul>
            <div id="avator">
              <div class="login-use">
                <el-avatar :size="40" :src="getAvatarUrl()" class="head-image"></el-avatar>
                <div class="dropdown_area_wrapper">
                  <div class="dropdown_area">
                    <div class="user-info">
                      <div>
                        您好，
                        <span class="user-name">
                          {{ user.displayName || user.userName }}
                        </span>
                      </div>
                    </div>
                    <ul>
                      <li>
                        <a @click.prevent="btnLinkClick('profile')">
                          <img src="/home/img/account_icon.png" />
                          <span>修改资料</span>
                        </a>
                      </li>
                      <li>
                        <a @click.prevent="btnLinkClick('password')">
                          <img src="/home/img/password_icon.png" />
                          <span>更改密码</span>
                        </a>
                      </li>
                      <li>
                        <a @click.prevent="btnLinkClick('logout/?redirect=/')">
                          <img src="/home/img/loginout_icon.png" />
                          <span>退出登录</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <aside class="common-aside">
        <div class="aside-div">
          <nav class="sign-aside">
            <ul class="default" style="">
              <h2 class="block-title">网站云</h2>
              <ul class="block-ul">
                <li class="block-item" :class="getClassName('/my/hosts,/my/create/empty')">
                  <a @click.prevent="btnLinkClick('my/hosts')" class="identical">
                    <span class="iconfont icon-yun"></span>
                    <span class="block-text">我的网站云</span>
                    <img src="/home/img/time_limit_icon.png" style="display: none" class="time-limit-icon" />
                  </a>
                </li>
                <li class="block-item" :class="getClassName('/my/templates')">
                  <a @click.prevent="btnLinkClick('my/templates')" class="identical">
                    <span class="iconfont icon-moban2"></span>
                    <span class="block-text">我的模板</span>
                  </a>
                </li>
                <li class="block-item" :class="getClassName('/my/plugins')">
                  <a @click.prevent="btnLinkClick('my/plugins')" class="identical">
                    <span class="iconfont icon-qiye"></span>
                    <span class="block-text">我的插件</span>
                  </a>
                </li>
                <li class="block-item" :class="getClassName('/my/tickets')">
                  <a @click.prevent="btnLinkClick('my/tickets')" class="identical">
                    <span class="iconfont icon-kefu2"></span>
                    <span class="block-text">我的工单</span>
                  </a>
                </li>
              </ul>
              <h2 class="block-title">辅助功能</h2>
              <ul class="block-ul">
                <li class="block-item" :class="getClassName('/my/orders')">
                  <a @click.prevent="btnLinkClick('my/orders')" class="identical">
                    <span class="iconfont icon-VIPbiaoshi"></span>
                    <span class="block-text">订单管理</span>
                  </a>
                </li>
                <li class="block-item" :class="getClassName('/my/invoices')">
                  <a @click.prevent="btnLinkClick('my/invoices')" class="identical">
                    <span class="iconfont icon-shenqingfapiao"></span>
                    <span class="block-text">发票管理</span>
                  </a>
                </li>
                <li class="block-item" :class="getClassName('/my/serviceCodes')">
                  <a @click.prevent="btnLinkClick('my/serviceCodes')" class="identical">
                    <span class="iconfont icon-weibiaoti-1-04"></span>
                    <span class="block-text">ICP备案服务码</span>
                  </a>
                </li>
              </ul>
              <ul class="block-ul creationnew">
                <h2 class="block-title">帮助中心</h2>
                <ul class="block-ul">
                  <li class="block-item">
                    <a href="https://sscms.com/docs/v7/host/" target="_blank" class="identical">
                      <span class="iconfont icon-usinghelp"></span>
                      <span class="block-text">网站云文档</span>
                    </a>
                  </li>
                </ul>
              </ul>
            </ul>
          </nav>
        </div>
      </aside>
      <div class="app-box">
        <div id="app" class="container">
          <div id="tabs">
            <tags-view />
            <app-main />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
// eslint-disable-next-line import/no-cycle
import utils from '@/utils';
// eslint-disable-next-line import/no-cycle
import api from '@/api/layout';
import { defineComponent } from 'vue';
import { IUser } from '@/types/models';
import { auth } from '@/store';
import AppMain from './components/AppMain.vue';
import TagsView from './components/TagsView.vue';

interface IState {
  user: IUser;
  isReady: boolean;
}

export default defineComponent({
  name: 'Layout',
  components: {
    AppMain,
    TagsView,
  },
  data() {
    return {
      user: {} as IUser,
      isReady: false,
    } as IState;
  },
  methods: {
    getClassName(list: string) {
      const paths = list.split(',');
      for (const path of paths) {
        if (path === this.$route.fullPath || `${path}/` === this.$route.fullPath) {
          return 'block-item-active';
        }
      }
      return '';
    },

    getAvatarUrl() {
      return utils.getAvatarUrl(this.user);
    },

    btnLinkClick(pageName: string) {
      utils.pageOpen(`/${pageName}`);
    },

    apiGet() {
      api.get((res) => {
        if (res.user) {
          this.user = res.user;

          auth.setUser(this.user);
          utils.loading(false);
          this.isReady = true;
        } else {
          utils.pageOpen('login');
        }
      });
    },
  },
  mounted() {
    this.apiGet();
  },
});
</script>
